module.exports = __webpack_public_path__ + "img/bg-prayer.jpg";